'use strict';
var parent = require('../../actual/object/keys');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/@okta/okta-auth-js/~/core-js/full/object/keys.js
// module id = 367
// module chunks = 0